import filter from "@domains/utils/filter";
import { sumOfTwo, totalPnlPerc } from "@domains/utils/holdings";
import { searchInArrayObject } from "@domains/utils/search";
import sort, { ESortOrder, stringSort } from "@domains/utils/sort";
import summarize from "@domains/utils/summarize";
export class PNLCommonUseCase {
    constructor(searchUsecase, filterUsecase, sortUseCase, summarizeUseCase, dashboardSummarizeUseCase) {
        this.searchUsecase = searchUsecase;
        this.filterUsecase = filterUsecase;
        this.sortUseCase = sortUseCase;
        this.summarizeUseCase = summarizeUseCase;
        this.dashboardSummarizeUseCase = dashboardSummarizeUseCase;
    }
    async dashboardSummarize(dashboardData, isSummarize) {
        return await this.dashboardSummarizeUseCase.getSummarizedData(dashboardData, isSummarize);
    }
    async getModifiedData(PNLReportData, combinedState, streamOn = false) {
        try {
            let searchData = await this.searchUsecase.getSearchData(PNLReportData, combinedState.searchState);
            let filterData = await this.filterUsecase.getFilteredData(searchData, combinedState.filterUiState, streamOn);
            let sortedData = await this.sortUseCase.getSortedData(filterData, combinedState.sortDataUiState);
            let summerizeData = await this.summarizeUseCase.getSummarizedData(sortedData, combinedState.isSummarize);
            return summerizeData;
        }
        catch (error) {
            console.log(error);
            return Object.assign(Object.assign({}, PNLReportData), { PnLData: Object.assign(Object.assign({}, PNLReportData === null || PNLReportData === void 0 ? void 0 : PNLReportData.PnLData), { pnLDetails: [] }) });
        }
    }
}
export class FilterUseCase {
    getFilteredData(PNLReportData, { simpleFilter, assetFilter, productAssetFilter, underlyingAsset, expiryMonth, instrumentType, optionType, strikePrice, }, streamOn) {
        var _a;
        const filterState = [];
        const filterStateForProductAssests = [{ key: ["edelweissProductShortCode"], value: [] }];
        let FilterData = PNLReportData.PnLData.pnLDetails;
        var isProductFilterAppiled = false;
        var isSimpleFiltersApplied = false;
        productAssetFilter === null || productAssetFilter === void 0 ? void 0 : productAssetFilter.filters.forEach((filter) => {
            if (filter.selected) {
                isProductFilterAppiled = true;
                filterStateForProductAssests[0].value.push(filter.key);
            }
        });
        if (isProductFilterAppiled) {
            FilterData = filter(FilterData, filterStateForProductAssests);
        }
        simpleFilter.filters.forEach((filter) => {
            if (filter.selected) {
                isSimpleFiltersApplied = true;
                filterState.push({ key: ["filterFlags", filter.key], value: true });
            }
        });
        if (isSimpleFiltersApplied) {
            if (!streamOn)
                sessionStorage.setItem("simpleFilter", JSON.stringify(filterState));
            FilterData = filter(FilterData, filterState);
        }
        else {
            sessionStorage.removeItem("simpleFilter");
        }
        let totalPnl = 0, realisedPnl = 0, unrealisedPnl = 0, totalInvestment = 0, unrealisedBuyValue = 0, realisedBuyValue = 0, daysPnLChange = 0;
        FilterData.map((x) => {
            totalPnl = sumOfTwo(totalPnl, x.totalPnL);
            realisedPnl = sumOfTwo(realisedPnl, x.realisedPnL);
            unrealisedPnl = sumOfTwo(unrealisedPnl, x.unrealisedPnL);
            totalInvestment = sumOfTwo(totalInvestment, Number(x.quantity) > 0
                ? sumOfTwo(x.unrealisedBuyValue, x.realisedBuyValue)
                : Number(x.sellValue));
            daysPnLChange = sumOfTwo(daysPnLChange, x.dayChange);
            unrealisedBuyValue = sumOfTwo(x.unrealisedBuyValue, unrealisedBuyValue);
            realisedBuyValue = sumOfTwo(x.realisedBuyValue, realisedBuyValue);
        });
        const pnLSummary = Object.assign(Object.assign({}, PNLReportData.PnLData.pnLSummary), { totalPnl: totalPnl.toString(), realisedPnl: realisedPnl.toString(), unrealisedPnl: unrealisedPnl.toString(), totalPnlChangePercent: totalPnlPerc(totalPnl, (_a = PNLReportData.PnLData.pnLSummary) === null || _a === void 0 ? void 0 : _a.totalInvestment), unrealisedPnlChangePercent: totalPnlPerc(unrealisedPnl, unrealisedBuyValue), realisedPnlChangePercent: totalPnlPerc(realisedPnl, realisedBuyValue), daysPnLChange: daysPnLChange.toString() });
        if (streamOn)
            pnLSummary.daysPnLChange = daysPnLChange.toString();
        return Object.assign(Object.assign({}, PNLReportData), { PnLData: Object.assign(Object.assign({}, PNLReportData.PnLData), { pnLDetails: FilterData, pnLSummary }), FilterData: {
                simpleFilter,
                assetFilter,
                productAssetFilter,
                underlyingAsset,
                expiryMonth,
                instrumentType,
                optionType,
                strikePrice,
            } });
    }
    detectSelectedFilter(filter, initFilterStateKey) {
        var _a;
        if ((filter === null || filter === void 0 ? void 0 : filter.name) && ((_a = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let applied = false;
            let filterState = [
                { key: [initFilterStateKey], value: [] },
            ];
            filter.filters.forEach((filter) => {
                if (filter.selected) {
                    applied = true;
                    filterState[0].value.push(filter.key);
                }
                return filter;
            });
            return {
                FilterApplied: applied,
                FilterState: filterState,
            };
        }
    }
}
export class SearchUseCase {
    getSearchData(PositionReportData, searchData) {
        // const PositionDetailsOpen = search(
        //   PositionReportData.PnLData.pnLDetails,
        //   "scripName",
        //   searchData
        // );
        const pnLDetails = searchInArrayObject(PositionReportData.PnLData.pnLDetails, searchData);
        const pnLSummary = PositionReportData.PnLData.pnLSummary;
        return Object.assign(Object.assign({}, PositionReportData), { PnLData: {
                pnLSummary,
                pnLDetails,
                pnlDataFlags: PositionReportData.PnLData.pnlDataFlags
            }, SearchData: searchData });
    }
}
export class SortUseCase {
    getSortedData(data, sortState) {
        var _a;
        let pnLDetails;
        if (sortState.sortName == "displayName") {
            pnLDetails = stringSort(data.PnLData.pnLDetails, sortState.sortName, sortState.order);
        }
        else {
            pnLDetails = sort(data.PnLData.pnLDetails, sortState.sortName, sortState.order);
        }
        let SortData = (_a = data === null || data === void 0 ? void 0 : data.SortData) === null || _a === void 0 ? void 0 : _a.map((e) => {
            return Object.assign(Object.assign({}, e), { order: sortState.sortName === e.sortName
                    ? sortState.order
                    : ESortOrder.UNCHANGED });
        });
        return Object.assign(Object.assign({}, data), { PnLData: Object.assign(Object.assign({}, data.PnLData), { pnLDetails }), SortData });
    }
}
export class SummarizedUseCase {
    async getSummarizedData(data, isSummarize) {
        if (isSummarize) {
            let { PnLData, IsSummarize } = data;
            let { pnLDetails, pnLSummary, pnlDataFlags } = PnLData;
            pnLSummary.realisedPnl;
            pnLSummary = Object.assign(Object.assign({}, pnLSummary), { realisedPnl: summarize(pnLSummary.realisedPnl), unrealisedPnl: summarize(pnLSummary.unrealisedPnl), totalPnl: summarize(pnLSummary.totalPnl), daysPnLChange: summarize(pnLSummary.daysPnLChange) });
            pnLDetails = pnLDetails.map((pnLDetail) => {
                return Object.assign(Object.assign({}, pnLDetail), { averageBuyPrice: summarize(pnLDetail.averageBuyPrice), averageSellPrice: summarize(pnLDetail.averageSellPrice), closingQuantity: summarize(pnLDetail.closingQuantity), investmentValue: summarize(pnLDetail.investmentValue), marketValue: summarize(pnLDetail.marketValue), quantity: summarize(pnLDetail.quantity), realisedAvgBuyPrice: summarize(pnLDetail.realisedAvgBuyPrice), realisedAvgSellPrice: summarize(pnLDetail.realisedAvgSellPrice), realisedPnL: summarize(pnLDetail.realisedPnL), realisedBuyValue: summarize(pnLDetail.realisedBuyValue), realisedQuantity: summarize(pnLDetail.realisedQuantity), realisedSellValue: summarize(pnLDetail.realisedSellValue), sellValue: summarize(pnLDetail.sellValue), totalPnL: summarize(pnLDetail.totalPnL), unrealisedAvgBuyPrice: summarize(pnLDetail.unrealisedAvgBuyPrice), unrealisedBuyQuantity: summarize(pnLDetail.unrealisedBuyQuantity), unrealisedBuyValue: summarize(pnLDetail.unrealisedBuyValue), unrealisedClosePrice: summarize(pnLDetail.unrealisedClosePrice), unrealisedMarketValue: summarize(pnLDetail.unrealisedMarketValue), unrealisedPnL: summarize(pnLDetail.unrealisedPnL), dayChange: summarize(pnLDetail.dayChange), unrealisedSellValue: summarize(pnLDetail.unrealisedSellValue) });
            });
            IsSummarize = isSummarize;
            return Object.assign(Object.assign({}, data), { PnLData: { pnLDetails, pnLSummary, pnlDataFlags }, IsSummarize });
        }
        return data;
    }
}
export class DashboardSummarizedUseCase {
    async getSummarizedData(data, isSummarize) {
        if (isSummarize) {
            const summarizeDashboard = data.dashboardSummary.map((x) => {
                return Object.assign(Object.assign({}, x), { investmentValue: summarize(x.investmentValue), marketValue: summarize(x.marketValue), realisedGain: summarize(x.realisedGain) });
            });
            const pnlSummary = Object.assign(Object.assign({}, data.pnlSummary), { realisedPnl: summarize(data.pnlSummary.realisedPnl), unrealisedPnl: summarize(data.pnlSummary.unrealisedPnl), totalPnl: summarize(data.pnlSummary.totalPnl), daysPnLChange: summarize(data.pnlSummary.daysPnLChange) });
            return Object.assign(Object.assign({}, data), { dashboardSummary: summarizeDashboard, pnlSummary });
        }
        return data;
    }
}
